import { render, staticRenderFns } from "./SjiModeration.vue?vue&type=template&id=3a98fc35&scoped=true"
import script from "./SjiModeration.vue?vue&type=script&lang=js"
export * from "./SjiModeration.vue?vue&type=script&lang=js"
import style0 from "./SjiModeration.vue?vue&type=style&index=0&id=3a98fc35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a98fc35",
  null
  
)

export default component.exports